<template>

	<slot name="content" :method="{edit, remove, addBook}"/>

</template>
<script>
import CATEGORY from '@/models/category'
import ShelfModal from '@/modals/shelf-instance'
import BookModal from '@/modals/book-instance'

export default {
	props: {
		shelf: {
			type: Object,
			required: true
		}
	},
	emits: [
		'removed', // shelf was removed
		'updated', // shelf was updated
		'book-added', // book was added to shelf
	],
	computed: {
		category() {
			return CATEGORY.find(this.shelf.category);
		}
	},
	methods: {

		// open shelf instance form modal
		edit() {
			this.$vfm.show({component: ShelfModal}, {
				idShelf: this.shelf.id,
				category: this.category,
				onSuccess: (mode, data) => this.$emit('updated', this.shelf.id, mode, data)
			});
		},

		// remove shelf by id
		remove() {
			const shelf = this.shelf;

			if (!confirm(`Удалить полку "${shelf.name}"?
Это действие сделает недоступными книги для просмотра в этой полке`)) return;

			this.userapi.post(`racks/delete/${shelf.id}`).then(response => {
				parseInt(response.data.result) && this.$emit('removed', shelf.id);
			});
		},

		// add book to shelf
		addBook() {
			this.$vfm.show({component: BookModal}, {
				shelf: _.objectPick(this.shelf, ['id', 'name']),
				onSuccess: (mode, data) => {
					(mode === 'add') && this.$emit('book-added', this.shelf.id, data);
				}
			});
		}

	},
	components: {
		// BookCard
	}
}
</script>